// extracted by mini-css-extract-plugin
export default {"blanket":"blacket_blanket__a0wRa"};